import { includes, last } from 'lodash';

import { Point, Matrix, TextureBrushBase } from 'cdl';

import { Tool } from '../view';

import { SelectAndTransformHandles } from './select-transform';

export const RenderInfoTool = Tool.extend({ typeName: 'RenderInfoTool',
  type: 'Final',
  toolbarName: 'renderInfoTool',
  initTool( view, figure ) {

    this.handles = new SelectAndTransformHandles({

      view: this.view,
      tool: this,

      editingItems: () => {
        const figure = this._figure;
        return figure ? [ figure ] : [];
      },

      getOriginalTransforms: () => {
        this._downFrame = this.computeRenderFrame_();
        this._downMatrix22 = this._polyregion.renderMatrix || new Matrix();
      },

      setOriginalTransforms: () => {
        // Directly handle revert in transformItems
      },

      computeItemsFrame_: this.computeRenderFrame_.bind(this),

      transformItems: this.transformItems.bind(this),

      itemsEnabledTransforms: () => {
        return {
          translate: true,
          scale: true,
          rotate: true
        };
      }
    });

    if( figure ) {
      this.startEdit(figure);
    }
  },

  computeRenderFrame_() {
    const polyregion = this._polyregion;
    return ( polyregion.renderFrame || polyregion.initialRenderFrame() ).transformed(this._figure.globalMatrix_());
  },

  transformItems( items, transform ) {
    const figure       = this._figure,
          polyregion   = this._polyregion,
          downFrame    = this._downFrame,
          downMatrix22 = this._downMatrix22;

    const mi = figure.matrix_().inverted();

    const mi_transform = Matrix.m( mi, transform );

    polyregion.renderMatrix = Matrix.m( Matrix.rotate(mi_transform.angle()), downMatrix22 );
    polyregion.renderFrame = downFrame.transformed(mi_transform);
  },

  startEdit( figure, point ) { const view = this.view;
    this._figure = figure;
    this._polyregion = point ? figure.polyregionAtPoint_(point) : last(figure._polyregions);
    this.handles.update();
    this.redraw();
    view.render$();
  },

  link( view ) {
    this.handles.create();
    // [TODO] Abstract
    const h = this.handles.handles; // grab internal handles
    h._fillColor       = '#6e78d1';
    h._fillOverColor   = '#243788';
    h._fillActiveColor = '#fb603d';
    h._strokeColor     = '#243788';


    view.on({ 'rendercomplete': this.on_rendercomplete }, this );
  },

  unlink( view ) {
    view.un(this);
    this.handles.dispose();
  },

  on_rendercomplete() {
    if( ! includes(this.view.figures,this._figure) ) {
      this._figure = null;
    }
    this.handles.update();
  },

  on_pointerdown({ view, event, isPrimary, docPoint }) {
    if( ! isPrimary ) {
      return;
    }

    const hs = this.handles;
    if( hs._editionMode ) {
      hs.up(event);
      return;
    }

    const leftClick = event.which === 1;
    if( ! leftClick ) {
      return;
    }

    if( hs.isHandle(event) ) {
      event.stopPropagation();
      hs.down(event);
    }
    else {

      const figure = event.figure; // [EVENTS] view.figureAtPoint(docPoint);
      if( figure && figure.isShape ) {
        this.startEdit(figure,docPoint);
      }
    }
  },
  on_pointermove( event ) {
    this.handles.move(event);
  },
  on_pointerup( event ) {
    this.handles.up(event);
  },

  draw( config ) {
    this.handles.draw( config );
  }

});


Tool.ClippingBounds = Tool.extend({ typeName: 'ClippingBoundsTool',
  type: 'Final',
  toolbarName: 'clippingBoundsTool',
  initTool( view,figure ) {

    this.handles = new SelectAndTransformHandles({

      view: this.view,
      tool: this,

      editingItems: () => {
        const figure = this._figure;
        return figure ? [ figure ] : [];
      },

      getOriginalTransforms: () => {
        this._downFrame = this.clippingFrame();
        this._downClippingBounds = this._brush.clippingBounds.clone();
        this._downTextureOffset = this._brush.textureOffset.clone();
        // this._downPin = this._figure.globalMatrix_().apply( this.clippingFrame().center );
      },

      setOriginalTransforms: () => {
        // Directly handle revert in transformItems
      },

      computeItemsFrame_: this.clippingFrame.bind(this),

      transformItems: this.transformItems.bind(this),

      itemsEnabledTransforms: () => {
        return {
          translate: true,
          scale: true
        };
      }
    });

    if( figure ) {
      this.startEdit(figure);
    }
  },
  startEdit( figure, point ) { const view = this.view;
    this._figure = null;
    if( figure.isShape ) {
      const polyregion = point ? figure.polyregionAtPoint_(point) : last(figure._polyregions);
      const brush = polyregion.brush;
      if( brush instanceof TextureBrushBase ) {
        this._figure = figure;
        this._polyregion = polyregion;
        this._brush = brush;
      }
    }
    this.handles.update();
    this.redraw();
    view.render$();
  },

  link( view ) {
    this.handles.create();

    const h = this.handles.handles;
    h._fillColor       = '#6e78d1';
    h._fillOverColor   = '#243788';
    h._fillActiveColor = '#fb603d';
    h._strokeColor     = '#243788';

    view.on({ 'rendercomplete': this.on_rendercomplete }, this );
  },
  unlink( view ) {
    view.un(this);
    this.handles.dispose();
  },

  on_rendercomplete() {
    if( ! includes(this.view.figures,this._figure) ) {
      this._figure = null;
    }
    this.handles.update();
  },

  on_pointerdown({ view, event, isPrimary, which, docPoint }) {
    if( ! isPrimary ) {
      return;
    }

    const hs = this.handles;
    if( hs._editionMode ) {
      hs.up(event);
      return;
    }

    const leftClick = which === 1;
    if( ! leftClick ) {
      return;
    }

    if( hs.isHandle(event) ) {
      event.stopPropagation();
      hs.down(event);
    }
    else {

      const figure = event.figure; // [EVENTS] view.figureAtPoint(docPoint);
      if( figure && figure.isShape ) {
        this.startEdit(figure,docPoint);
      }
    }
  },
  on_pointermove( event ) {
    this.handles.move(event);
  },
  on_pointerup( event ) {
    this.handles.up(event);
  },

  draw(config) {
    this.handles.draw(config);
  },

  renderFrame() {
    const figure = this._figure, polyregion = this._polyregion;
    const matrix = figure.globalMatrix_();
    return ( polyregion.renderFrame || polyregion.initialRenderFrame() ).transformed(matrix);
  },

  clippingFrame() {
    return this._brush.clippingFrame_(this.renderFrame());
  },

  transformItems( items, transform ) {

    const brush   = this._brush,
          frame_0 = this._downFrame;

    const frame_1 = frame_0.transformed(transform);

    const rotate = Matrix.rotate(-frame_0.angle());

    const fr_0 = frame_0.transformed(rotate);

    const ocb = this._downClippingBounds;

    const scale = Matrix.scale( ocb.width  / fr_0.width,
                                ocb.height / fr_0.height );

    const frs_0 = fr_0.transformed(scale);

    const translate = Matrix.translate( ocb.lx_ly .minus( frs_0.p0 ) );

    const ncb = frame_1.transformed( Matrix.concat(translate,scale,rotate) ).bounds;

    brush.clippingBounds = ncb;

    const dto = this._downTextureOffset;

    const nto = new Point( ( ocb.lx + dto.x * ocb.width  - ncb.lx ) / ncb.width  ,
                           ( ocb.ly + dto.y * ocb.height - ncb.ly ) / ncb.height );

    brush.textureOffset = nto;
  }

});

Tool.RenderInfo = RenderInfoTool;



/** WEBPACK FOOTER **
 ** ./src/ui/tool/render-info.js
 **/